import React from 'react'

import {
  Item,
  FlightItemDescription,
  SecondaryText,
  ListPredecoration,
  ItemHeading,
} from './Styles'
import { AirportDetailsType } from 'utils/types'

interface Props {
  item: AirportDetailsType
  children: React.ReactNode
}

const FlightItem = (props: Props) => (
  <Item key={props.item.iata}>
    <ListPredecoration>{props.item.iata}</ListPredecoration>
    <FlightItemDescription>
      <div>
        <ItemHeading>{props.item.city}</ItemHeading>
        {props.item.name === props.item.city ? null : (
          <SecondaryText>{props.item.name}</SecondaryText>
        )}
        {props.children}
      </div>
    </FlightItemDescription>
  </Item>
)

export default React.memo(FlightItem)
